// extracted by mini-css-extract-plugin
export default {"greeting":"style_greeting__z3+bT","greeting__title":"style_greeting__title__Ekj3L","greeting__goal":"style_greeting__goal__TTzSr"};